import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {PageHeader} from "../components/layout/PageHeader";
import {Col, Form, Input, Pagination, Row, Select, Spin} from "antd";
import {getCertificates, useCertificates} from "../hooks/certificate";
import {
    CertificateListDto,
    CertificateListItemDto,
    CertificateListParameterDto,
    TemplateListItemDto
} from "../generated-api";
import {useHistory} from "react-router-dom";
import {DEFAULT_PAGE_SIZE} from "../constants";
import {Award, Filter, PlusCircle} from "react-feather";
import {CertificatesList} from "../components/CertificatesList";
import {getTemplate, useTemplate} from "../hooks/template";
import {BackButton} from "../components/layout/BackButton";
import {filtersSubject, useFilters} from "../hooks";
import { CertificatesListSearch } from "../components/CertificatesListSearch";

export function CertificatesPage() {
    const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

    const {t} = useTranslation();
    const history = useHistory();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
    const templateResponse = useTemplate();
    const templates: TemplateListItemDto[] = templateResponse.data || [];
    const certificatesResponse = useCertificates();
    const certificatesData: CertificateListDto = certificatesResponse.data || {};
    const columns: CertificateListParameterDto[] = certificatesData.columns || [];
    const certificates: CertificateListItemDto[] = certificatesData.items || [];
    const totalCertificates = certificatesData.total || certificates.length;
    const filters: any = useFilters();
    const [filterCollapsed, setFilterCollapsed] = useState(false);
    const [filterTemplate, setFilterTemplate] = useState<any>(filters.filterTemplate);
    const [query, setQuery] = useState(filters.query);
    
    useEffect(() => {
        getTemplate(true).then().catch(console.error);
    }, [true]);
    
    useEffect(() => {
        if (filterTemplate && (!query || query.length >= 3)) {
            getCertificates((page - 1) * pageSize, pageSize, filterTemplate, query || undefined).then().catch(console.error);
            filtersSubject.next({filterTemplate, query});
        }
    }, [page, pageSize, query, filterTemplate]);

    return (
        <Spin spinning={certificatesResponse.loading}>
            <PageHeader/>
            <div className={'top-block accent4-background'}>
                <div className={'flex-row'}>
                    <h1 className={'h1 flex-auto'}><BackButton/><Award/>{t('certificates.title')}</h1>
                    <a href={'/users'} className={'title-icon-button mr-1 ' + (filterCollapsed ? '' : 'toggle')}
                       onClick={event => {
                           event.preventDefault();
                           setFilterCollapsed(!filterCollapsed);
                       }}>
                        <Filter/>
                    </a>
                    <a href={'/certificates/add'} className={'title-icon-button'}
                       onClick={event => {
                           event.preventDefault();
                           history.push('/certificates/add');
                       }}>
                        <PlusCircle/>
                    </a>
                </div>
                <Form className={'pt-0 ' + (filterCollapsed ? 'collapsed' : 'expanded')}>
                    <Row className={'row-offset'}>
                        <Col span={24} md={12} lg={8}>
                            <Form.Item className={'mb-0 mt-15'}>
                                <Select placeholder={t('certificates.filterTemplate')} allowClear showSearch
                                        style={{width: '100%'}}
                                        value={filterTemplate}
                                        onChange={event => {
                                            setFilterTemplate(event);
                                            setQuery('');
                                        }}
                                        filterOption={(input, option): any =>
                                            String((option || {}).children || '').toLowerCase().indexOf(String(input || '').toLowerCase()) >= 0
                                        }>
                                    {templates.map((item) =>
                                        <Select.Option key={item.id} value={String(item.id)}>
                                            {item.name}
                                        </Select.Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24} md={12} lg={8}>
                            <Form.Item className={'mb-0 mt-15'}>
                                <Input disabled={!filterTemplate} value={query} placeholder={t('general.search')}
                                       onChange={event => setQuery(event.target.value)}/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div className={'subpage-content'}>
                {!!filterTemplate &&
                (filterTemplate === EMPTY_GUID
                ? <CertificatesListSearch
                    certificates={certificates}
                    multiSelect={false}
                    onClick={(certificate: CertificateListItemDto) => {
                        history.push('/certificates/' + certificate.id)
                    }}/>
                : <CertificatesList
                    certificates={certificates}
                    columns={columns}
                    onClick={(certificate: CertificateListItemDto) => {
                        history.push('/certificates/' + certificate.id)
                    }}
                />)
                }
                {!!filterTemplate && totalCertificates > pageSize &&
                <Pagination showSizeChanger onChange={setPage} onShowSizeChange={(c, size) => setPageSize(size)} pageSize={pageSize} total={totalCertificates} current={page}
                            defaultCurrent={page}/>
                }
                {!filterTemplate &&
                <div className={'no-data'}>{t('certificates.selectTemplate')}</div>
                }
            </div>
        </Spin>
    )
}
